module.exports = __webpack_public_path__ + "img/ecofurn-ekotuoli.e0745cba.jpeg";